module.exports = __webpack_public_path__ + "img/broadcast-test-icon3.2e2c4835.png";